import * as React from 'react';
import styled from 'styled-components';
import ReactSVG from 'react-svg';

const StyledBadgeIcon = styled.div`
    position: relative;
    margin-right: ${props => props.marginRight ? props.marginRight : '5px'};
`;

const StyledCountText = styled.div`
    color: ${props => props.color ? props.color : '#265a9c'};
    font-size: x-small;
    font-weight: bold;
    margin-top: 8px;
    margin-left: 15px;
`;

const BadgeIcon = (props) => (
    <StyledBadgeIcon marginRight={props.marginRight}>
        <ReactSVG
            path={props.path}
            style={{
                fill: props.color ? props.color : '#265a9c',
                width: '15px',
                height: '15px',
                position: 'absolute'
            }}
        />
        <StyledCountText color={props.color}>
            {props.count}
        </StyledCountText>
    </StyledBadgeIcon>
);

export default BadgeIcon;



// WEBPACK FOOTER //
// ./src/components/BadgeIcon.jsx